import React, { useContext } from 'react';
import Icon from 'component/icon';
import { TableContext } from './context';

const ExpandIcon = (props) => {
    const { row } = props;
    const {
        rowKey,
        propExpandedRows,
        setTableExpandedRows,
        expandedRows,
        onChangeExpandedRowsRef
    } = useContext(TableContext);

    const currExpanded = expandedRows.includes(row[rowKey]);

    const onClick = () => {
        const result = expandedRows.filter((key) => key !== row[rowKey]);
        if (!currExpanded) {
            result.push(row[rowKey]);
        }
        if (!propExpandedRows) {
            setTableExpandedRows(result);
        }
        onChangeExpandedRowsRef.current?.(result);
    };

    return (
        <div
            className="flex justify-center items-center
                w-[21px] h-[21px] rounded-full cursor-pointer text-gray-dark02 dark:text-white"
            onClick={onClick}
        >
            <Icon name={currExpanded ? 'expand_less' : 'expand_more'} />
        </div>
    );
};

export default ExpandIcon;
